module.exports = __webpack_public_path__ + "static/media/exclaimGrey.3aa152eb.svg";